import { observer } from 'mobx-react';
import React from 'react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { findLink } from '../../../../../LinkyLinky';
import ParticipantsStore from '../../../../../ParticipantsStore';
import { T } from '../../../../../Translations';
import ModalStore from '../../../../Modal/Store';
import ActionMenu from '../ActionMenu';
import ReclaimLicensesModal from './ReclaimLicensesModal';

interface Props {
  store: ParticipantsStore;
}

function ReclaimLicenses({ store }: Props) {
  const modalStore = React.useRef(new ModalStore()).current;
  return findLink('bulk-reclaim-license', store.links)
    .map((link) => (
      <>
        <ReclaimLicensesModal store={store} modalStore={modalStore} />
        <ActionMenu
          content={
            <button onClick={modalStore.open} key={link.rel} className="px-4 py-2.5 text-red-600">
              <T kind="No Longer with Company" />
            </button>
          }
        />
      </>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ReclaimLicenses);
